import ComponentPlaceholder from 'components/ComponentPlaceholder';
import { LayoutContainer } from 'components/Layout';
import Message, { mapSeverityToVariant } from 'components/Message';
import Text from 'components/Text';
import type {
	Field,
	MessageSeverity,
	SitecoreBlockProps,
} from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';

interface Props extends SitecoreBlockProps {
	fields?: {
		description?: Field<string>;
		heading?: Field<string>;
		systemMessageActivated?: Field<boolean>;
		systemMessageHeading?: Field<string>;
		systemMessageSeverity: Field<MessageSeverity>;
		systemMessageText?: Field<string>;
	};
}

export default function FAQHeading({ fields, params }: Props) {
	if (!fields) {
		return null;
	}

	const {
		description,
		heading,
		systemMessageActivated,
		systemMessageHeading,
		systemMessageSeverity,
		systemMessageText,
	} = fields;

	if (!heading?.value || !description?.value) {
		return (
			<ComponentPlaceholder
				className={getEditorMargin(params)}
				componentName="FAQHeading"
				description="Requires a heading or description"
			/>
		);
	}

	return (
		<LayoutContainer
			id={params?.anchor}
			outerClassName={getEditorMargin(params)}
		>
			<div className="max-w-col-6">
				<Text as={params?.heading || 'h1'} className="mb-2" field={heading} />
				<Text as="pLarge" field={description} />
				{systemMessageActivated?.value && systemMessageText?.value && (
					<Message
						variant={mapSeverityToVariant(systemMessageSeverity.value)}
						heading={systemMessageHeading?.value}
						text={systemMessageText?.value}
						className="mt-8"
					/>
				)}
			</div>
		</LayoutContainer>
	);
}
FAQHeading.displayName = 'FAQHeading';
